import { Component, OnInit } from '@angular/core';
import { CommonapiService } from '../shared/services/commonapi.service';
import { Swiper } from 'swiper';
import { Router } from '@angular/router';
import * as AOS from 'aos';
import { HomeService } from '../shared/services/home.service';
import {Title } from "@angular/platform-browser";

//jquery declaration
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
  bounce: any;
  public safetyProgram: any = new Array();
  public safetyTraining: any = new Array();
  public safetyInspection: any = new Array();
  public safetyDetails: any = new Array();
  public recentNews: any = new Array();
  public feedbacks: any = new Array();
  public IsProgram: Boolean = true;
  public IsTraining: Boolean = false;
  public IsInspection: Boolean = false;

  public cOpt: any = {
    startVal: 0,
    decimalPlaces: 0,
    duration: 1
  };

  public  configSwiper = new Swiper('.swiper', {
    // Optional parameters
    direction: 'vertical',
    loop: true,
  
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },
  
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  
    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });

  // public config: new Swiper( {
  //   pagination: { el: '.swiper-pagination', clickable: true },
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev'
  //   },
  //   spaceBetween: 30,
  //   autoplay: {
  //     delay: 10000,
  //     disableOnInteraction: false,
  //   },
  //   fadeEffect: {
  //     crossFade: true
  //   },
  // });

  constructor(
    private commonApiService: CommonapiService,
    public router: Router,
    private homeService:HomeService,
    private titleService: Title,
  ) { }

  async ngOnInit(): Promise<void> {
    this.isotopeFilter("filter-program");
    this.topposition();
    this.titleService.setTitle("Safety Consultants | OSHA Compliance | CO, TX, AZ, FL, Nationwide");
    await this.homeService.getHomeDetails().then(data => {
      this.safetyProgram = data.filter(x => x.type.toLowerCase().toString().includes("program"));
      this.safetyTraining = data.filter(x => x.type.toLowerCase().toString().includes("training"));
      this.safetyInspection = data.filter(x => x.type.toLowerCase().toString().includes("inspection"));
    });

    const _clientObj = {
      Mode: "SEARCH",
      FeedbackId: 0,
      Name: "",
      Rating: 0,    
      SortBy: "id",
      Sort: "DESC",  
      PageNumber: 1,
      NoOfRecordsPerPage: 100,
      DisplayFilter: 'Active',
      PropertyName: "Id",
      SortingBy: false,
    };

    let _cdt = await this.commonApiService.postData("api/MarketingApi/DBFeedbackList/", _clientObj).toPromise();


    console.log("data",_cdt);

    if (_cdt && _cdt[0] && _cdt[0].dataSet && _cdt[0].dataSet.mlFeedbackList && _cdt[0].dataSet.mlFeedbackList.length > 0) {
      this.feedbacks = _cdt[0].dataSet.mlFeedbackList;
    }
    else {
      this.feedbacks = new Array();
    }

    // Intro carousel
    var introCarousel = $(".carousel");
    var introCarouselIndicators = $(".carousel-indicators");
    introCarousel.find(".carousel-inner").children(".carousel-item").each(function (index) {
      (index === 0) ?
        introCarouselIndicators.append("<li data-target='#introCarousel' data-slide-to='" + index + "' class='active'></li>") :
        introCarouselIndicators.append("<li data-target='#introCarousel' data-slide-to='" + index + "'></li>");
    });

    introCarousel.on('slid.bs.carousel', function (e) {

    });

    AOS.init();
  }

  topposition() {

    // if ($('#preloader').length) {
    //   $('#preloader').delay(500).fadeOut('slow', function() {
    //     $(this).remove();
    //   });
    // }
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
  }

  isotopeFilter(filterBy) {

    if (filterBy === 'program') {
      this.IsProgram = true;
      this.IsTraining = false;
      this.IsInspection = false;
    }
    else if (filterBy === 'training') {
      this.IsProgram = false;
      this.IsTraining = true;
      this.IsInspection = false;
    }
    else if (filterBy === 'inspection') {
      this.IsProgram = false;
      this.IsTraining = false;
      this.IsInspection = true;
    }

    AOS.init();
  }

}
